import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { Chart as ChartJS, LinearScale, PointElement, LineElement, Tooltip, Legend, CategoryScale, BarElement, TimeScale, LineController, BarController } from 'chart.js';
import { Line, Bar, Chart } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import Grid from "@mui/material/Grid2";
import "../trendStyles.scss";
import { Box, IconButton, MenuItem, Modal, Select, Stack, Typography } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import moment from "moment";
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

// Register the necessary components with ChartJS
ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend, CategoryScale, BarElement, TimeScale, LineController, BarController);



export interface ChartsListProps {
    mergedActiveProfile: any
    filteredData: any[],
    filters: any[]
}

const internalTabs = [
    { "name": "charts", "value": "charts", icon: <AssessmentIcon />, svg: undefined },
    { "name": "table", "value": "table", icon: <TableRowsIcon />, svg: undefined },
]

interface IChartElement {
    width: '30vw' | '45vw' | '90vw' | '95vw' | '100vw',
    config: any
    fromModal: boolean,
    setShowChartInmodal: (value: any) => void
    filteredData: any[],
    filters: any[]
}

interface IHeaderCardVariable {
    variableName: string,
    variableValue: number,
    variableDate: Date,
    variableLastValue: number
    variableLastValueDate: Date,
    variableValueChange: number| undefined,
    variableValueChangeSate: string,
}

const ChartElement = ({ width, config, fromModal, setShowChartInmodal, filteredData, filters }: IChartElement) => {

    const { fieldActivities } = useSelector((state) => state.location);

    const paginationModel = { page: 0, pageSize: 10 };

    const onClickChangeSummaryView = (tabId: string) => {
        setactiveSummaryView(tabId)
    }

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0].value)

    const [sortElementForChat, setSortElementForChart] = useState<any>(undefined)

    const [dataColumns, setDataColumns] = useState<GridColDef[]>([])

    const [dataTable, setDataTable] = useState<any[]>([])

    useEffect(() => {
        if (config) {
            const chartsData: any = {
                labels: [],
                mainDataset: [],
                minDataset: [],
                averageDataset: [],
                maxDataset: [],
            }

            const tableData: any = []

            const minSetpointValue = config?.min
            const maxSetpointValue = config?.max
            const averageSetpointValue = config?.average

            let sortActivities: any[] = [...fieldActivities].sort((a: any, b: any) => new Date(b.executedDate).getTime() - new Date(a.executedDate).getTime());

            for (const filter of filters) {
                const filterData = filteredData.find(f => f.name === filter.name);
                if (filterData) {
                    if (filterData.action === 'greater') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                    } else if (filterData.action === 'less') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                    } else if (filterData.action === 'equal') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                    } else if (filterData.action === 'different') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                    } else if (filterData.action === 'dissable') {
                        sortActivities = sortActivities || [];
                    } else if (filterData.action === 'include' && filterData.value.length > 0) {
                        sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                    } else if (filterData.action === 'equalAfter') {
                        sortActivities = sortActivities.filter((x) => {
                            const locationDate = moment(x.executedDate);
                            return locationDate.isSameOrAfter(filterData.value, 'day')
                        });
                    } else if (filterData.action === 'equalBefore') {
                        sortActivities = sortActivities.filter((x) => {
                            const locationDate = moment(x.executedDate)
                            return locationDate.isSameOrBefore(filterData.value, 'day')
                        });
                    }
                }
            }

            sortActivities?.forEach((act: any) => {
                const variables = act?.variables?.find((v: any) => v?.id === config?.variableId)

                let value = variables?.value

                if (typeof value !== "number") {
                    try {
                        value = parseFloat(value)                        
                    } catch (error) {
                        
                    }
                }

                if (variables && typeof value === 'number') {
                    chartsData.labels.push(act?.executedDate)
                    chartsData.mainDataset.push(value)

                    if (minSetpointValue) {
                        chartsData.minDataset.push(minSetpointValue)
                    }
                    if (maxSetpointValue) {
                        chartsData.maxDataset.push(maxSetpointValue)
                    }
                    if (averageSetpointValue) {
                        chartsData.averageDataset.push(averageSetpointValue)
                    }

                    let state = "normal"

                    if (value > maxSetpointValue || value < minSetpointValue) {
                        state = "out of range"
                    } else if (value < (1.2 * averageSetpointValue) || value > (0.8 * averageSetpointValue)) {
                        state = "normal"
                    } else if (value > (0.85 * maxSetpointValue) || value < (1.15 * minSetpointValue)) {
                        state = "close to limit"
                    }

                    const tableElement = {
                        id: act?.fieldActivityId,
                        fecha: act?.executedDate,
                        [config?.variableName]: value,
                        state
                    }

                    tableData.push(tableElement)

                }
            })

            setDataTable(tableData)

            setDataColumns([
                { field: 'fecha', headerName: 'Fecha', flex: 1 },
                {
                    field: config?.variableName, headerName: config?.variableName, flex: 1, renderCell: (params) => {
                        return (
                            <div style={{
                                backgroundColor: params.row.state === "out of range" ? "#F44336" : params.row.state === "close to limit" ? "#FFCA28" : "#46B406",
                                width: "100%",
                                height: "100%",
                                borderRadius: "5px",
                                color: "#fff",
                                textAlign: "center",
                                fontWeight: "bold",
                            }}>
                                {params.value}
                            </div>
                        )
                    }
                },
            ])

            const datasets = []

            if (chartsData.mainDataset.length > 0) {

                let type = config?.type === "bar" ? "bar" : 'line'

                if (chartsData.mainDataset.length === 1) {
                    type = "bar"
                }

                datasets.push({
                    label: 'Main',
                    data: chartsData.mainDataset,
                    backgroundColor: 'rgba(75, 192, 192, 0.2)',
                    borderColor: 'rgb(6, 22, 243)',
                    borderWidth: 2,
                    type,
                })
            }

            if (chartsData.minDataset.length > 0) {

                let data:any[] = chartsData.minDataset

                datasets.push({
                    label: 'Min',
                    data: chartsData.minDataset,
                    borderColor: 'rgb(165, 103, 4)',
                    backgroundColor: 'rgb(165, 103, 4)',
                    borderDash: [5, 5],
                    pointRadius: 0,
                    fill: false,
                    type: data.length===1 ?'bar' :'line',
                    order: 1
                })
            }

            if (chartsData.averageDataset.length > 0) {

                let data:any[] = chartsData.averageDataset

                datasets.push({
                    label: 'Average',
                    data: chartsData.averageDataset,
                    borderColor: 'rgb(6, 246, 154)',
                    backgroundColor: 'rgb(6, 246, 154)',
                    borderDash: [5, 5],
                    pointRadius: 0,
                    fill: false,
                    type: data.length===1 ?'bar' :'line',
                    order: 1
                })
            }

            if (chartsData.maxDataset.length > 0) {

                let data:any[] = chartsData.maxDataset

                datasets.push({
                    label: 'Max',
                    data: chartsData.maxDataset,
                    borderColor: 'rgba(255, 99, 132, 1)',
                    backgroundColor: 'rgba(255, 99, 132, 1)',
                    borderDash: [5, 5],
                    pointRadius: 0,
                    fill: false,
                    type: data.length===1 ?'bar' :'line',
                    order: 1
                })
            }

            setSortElementForChart({
                labels: chartsData.labels,
                datasets: datasets
            })
        }
    }, [fieldActivities, config, filteredData])

    return (
        <Grid className='chart-element' style={{ width }}>
            <Grid className='chart-icons-container'>
                {/* Icons left */}
                <Grid>
                    {
                        internalTabs.map((item, index) => {
                            return (
                                <IconButton
                                    onClick={() => onClickChangeSummaryView(item.value)}
                                    key={index}
                                    sx={{
                                        backgroundColor: activeSummaryView === item.value ? "#1976d2" : "#f0f0f0",
                                        color: activeSummaryView === item.value ? "#fff" : "#000",
                                        "&:hover": {
                                            backgroundColor: activeSummaryView === item.value ? "#42a5f5" : "#f0f0f0",
                                        },
                                    }}
                                >
                                    {item.icon ? item.icon : <img src={item?.svg || ""} alt="icon" width={25} height={25} />}
                                </IconButton>
                            )
                        })
                    }
                </Grid>
                {/* Icons Right */}
                <Grid>
                    <IconButton
                        onClick={() => setShowChartInmodal(fromModal ? undefined : config)}
                    >
                        {fromModal ? (
                            <ZoomInMapIcon />
                        ) : (
                            <ZoomOutMapIcon />
                        )}
                    </IconButton>
                </Grid>
            </Grid>
            <Grid className="chart-title">{config?.variableName}</Grid>
            {/* Table */}
            {activeSummaryView === "table" && (
                <Grid className='chart-table' sx={{ height: width === '90vw' ? '500px' : '200px' }}>
                    <DataGrid
                        rows={dataTable}
                        columns={dataColumns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#316EBC",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                            "& .MuiDataGrid-footerContainer": {
                                minHeight: "30px", // Reduce the height of the pagination area to minimum
                                maxHeight: "30px",
                            },
                            height: width === '90vw' ? 'calc(500px - 30px)' : 'calc(250px - 30px)',
                        }}
                        getRowId={(row) => row.id}
                    />
                </Grid>
            )}
            {/* Chart */}
            {activeSummaryView === "charts" && (
                <Grid className='chart-chart' sx={{ height: width === '90vw' ? '500px' : '200px' }}>
                    {sortElementForChat && (
                        <Chart
                            type={'bar'}
                            data={sortElementForChat}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: {
                                        position: 'top',
                                    },
                                    tooltip: {
                                        mode: 'index',
                                        intersect: false,
                                        callbacks: {
                                            label: function (context) {
                                                if (context.dataset.label === 'Main') {
                                                    return `${context.dataset.label}: ${context.raw}`;
                                                }
                                                return ''; // Hide other datasets' tooltips
                                            }
                                        }
                                    }
                                },
                                scales: {
                                    x: {
                                        title: {
                                            display: true,
                                            text: 'Dates'
                                        },
                                        type: 'time',
                                        time: {
                                            unit: 'month',
                                            tooltipFormat: 'yyyy-MM-dd',
                                            displayFormats: {
                                                month: 'MMM yyyy'
                                            }
                                        }
                                    },
                                    y: {
                                        title: {
                                            display: true,
                                            text: 'Values'
                                        },
                                    }
                                }
                            }}
                        />)}
                </Grid>
            )}
        </Grid>
    )
}

export const ChartsList = ({ mergedActiveProfile, filteredData, filters }: ChartsListProps) => {

    const { fieldActivities, waterTests } = useSelector((state) => state.location);

    const [showChartInmodal, setShowChartInmodal] = useState(undefined)

    const [headerVariableCards, setHeaderVariableCards] = useState<IHeaderCardVariable[]>([])  


    useEffect(() => {

        if (mergedActiveProfile?.config) {

            const variablesForHeader: IHeaderCardVariable[] = []

            let waterSortActivities: any[] = [...waterTests].sort((a: any, b: any) => new Date(b.samplingDate).getTime() - new Date(a.samplingDate).getTime());

            const lastWaterTest = waterSortActivities?.[0]
            const secondWaterTest = waterSortActivities?.[1]

            if (lastWaterTest){

                let firstActivityvalue = lastWaterTest['freeWaterPercentage'];
                let secondActivityvalue = secondWaterTest?.['freeWaterPercentage'];

                if (typeof firstActivityvalue !== "number") {
                    try {
                        firstActivityvalue = parseFloat(firstActivityvalue)
                    } catch (error) {

                    }
                }

                const variationVariable = (firstActivityvalue - secondActivityvalue) / firstActivityvalue * 100

                console.log({lastWaterTest})

                let variableValueChangeSate = 'normal'

                if (variationVariable > 0) {
                    variableValueChangeSate = 'increased'
                } else if (variationVariable < 0) {
                    variableValueChangeSate = 'decreased'
                }

                if (typeof secondActivityvalue !== "number") {
                    try {
                        secondActivityvalue = parseFloat(secondActivityvalue)
                    } catch (error) {

                    }
                }

                const hasPreviousValue = secondActivityvalue !== undefined && secondActivityvalue !== null

                let variableDate:any = lastWaterTest['samplingDate']?.split('T')[0]

                if (variableDate) {
                    try {
                        variableDate = moment(variableDate).format('DD/MM/YYYY')
                    } catch (error) {
                        
                    }
                }

                let variableLastValueDate:any = secondWaterTest?.['samplingDate']?.split('T')[0]

                if (variableLastValueDate) {
                    try {
                        variableLastValueDate = moment(variableLastValueDate).format('DD/MM/YYYY')
                    } catch (error) {
                        
                    }
                }

                console.log({variableDate})
                
                variablesForHeader.push({
                    variableName: '% AyS',
                    variableValue: firstActivityvalue,
                    variableDate: variableDate,
                    variableLastValue: hasPreviousValue ? secondActivityvalue : undefined,
                    variableLastValueDate: hasPreviousValue ? variableLastValueDate : undefined,
                    variableValueChange: hasPreviousValue ? variationVariable :undefined,
                    variableValueChangeSate,
                })
            }


            let sortActivities: any[] = [...fieldActivities].sort((a: any, b: any) => new Date(b.executedDate).getTime() - new Date(a.executedDate).getTime());

            for (const filter of filters) {
                const filterData = filteredData.find(f => f.name === filter.name);
                if (filterData) {
                    if (filterData.action === 'greater') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] > filterData.value);
                    } else if (filterData.action === 'less') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] < filterData.value);
                    } else if (filterData.action === 'equal') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] === filterData.value);
                    } else if (filterData.action === 'different') {
                        sortActivities = sortActivities.filter((x) => x[filter.field] !== filterData.value);
                    } else if (filterData.action === 'dissable') {
                        sortActivities = sortActivities || [];
                    } else if (filterData.action === 'include' && filterData.value.length > 0) {
                        sortActivities = sortActivities.filter((x) => filterData.value.includes(x[filter.field]));
                    } else if (filterData.action === 'equalAfter') {
                        sortActivities = sortActivities.filter((x) => {
                            const locationDate = moment(x.executedDate);
                            return locationDate.isSameOrAfter(filterData.value, 'day')
                        });
                    } else if (filterData.action === 'equalBefore') {
                        sortActivities = sortActivities.filter((x) => {
                            const locationDate = moment(x.executedDate)
                            return locationDate.isSameOrBefore(filterData.value, 'day')
                        });
                    }
                }
            }

            for (const config of mergedActiveProfile?.config) {
                const variableID = config?.variableId
                let firstActivity: any = null;
                let secondActivity: any = null;

                for (const act of sortActivities) {

                    const allVariables =[
                        ...act?.variables||[],
                        ...act?.diagnosticVariables||[]
                    ]

                    const variable = allVariables?.find((v: any) => v?.id === variableID);
                    if (variable) {
                        if (!firstActivity) {
                            firstActivity = {
                                ...act,
                                variables: allVariables
                            };
                        } else if (!secondActivity) {
                            secondActivity = {
                                ...act,
                                variables: allVariables
                            };
                            break; // Exit loop once both activities are found
                        }
                    }
                }

                let firstActivityvalue = firstActivity?.variables?.find((v: any) => v?.id === variableID)?.value;
                let secondActivityvalue = secondActivity?.variables?.find((v: any) => v?.id === variableID)?.value;

                if (typeof firstActivityvalue !== "number") {
                    try {
                        firstActivityvalue = parseFloat(firstActivityvalue)
                    } catch (error) {

                    }
                }

                if (typeof secondActivityvalue !== "number") {
                    try {
                        secondActivityvalue = parseFloat(secondActivityvalue)
                    } catch (error) {

                    }
                }

                const variationVariable = (firstActivityvalue - secondActivityvalue) / firstActivityvalue * 100

                let variableValueChangeSate = 'normal'

                if (variationVariable > 0) {
                    variableValueChangeSate = 'increased'
                } else if (variationVariable < 0) {
                    variableValueChangeSate = 'decreased'
                }

                const hasPreviousValue = secondActivityvalue !== undefined && secondActivityvalue !== null

                variablesForHeader.push({
                    variableName: config?.variableName,
                    variableValue: firstActivityvalue,
                    variableDate: firstActivity?.executedDate,
                    variableLastValue: hasPreviousValue ? secondActivityvalue : undefined,
                    variableLastValueDate: hasPreviousValue ? secondActivity?.executedDate : undefined,
                    variableValueChange: hasPreviousValue ? variationVariable :undefined,
                    variableValueChangeSate,
                })
            }

            setHeaderVariableCards(variablesForHeader)
        }

    }, [fieldActivities, mergedActiveProfile, filteredData])


    return (
        <>
            <Modal
                open={showChartInmodal !== undefined}
                onClose={() => setShowChartInmodal(undefined)}
            >
                <Box className='chart-modal-container'>
                    <ChartElement
                        width="90vw"
                        config={showChartInmodal}
                        setShowChartInmodal={setShowChartInmodal}
                        fromModal={true}
                        filteredData={filteredData}
                        filters={filters}
                    />
                </Box>
            </Modal>
            {mergedActiveProfile?.config?.length > 0 && (
                <Grid className="chart-last-variables-status">
                    {headerVariableCards?.map((p: any, index: number) => {
                        return (
                            <Grid key={index} className="chart-card-container">
                                <Grid className="variable-name">{p.variableName}</Grid>
                                <Grid className="variable-value">
                                    {p.variableValueChange > 0 ? (
                                        <ArrowUpwardIcon sx={{ color: p.variableValueChange > 0 ? "#0AC665" : p.variableValueChange < 0 ? "#F44336" : "#000" }} />
                                    ) : p.variableValueChange < 0 ? (
                                        <ArrowDownwardIcon sx={{ color: p.variableValueChange > 0 ? "#0AC665" : p.variableValueChange < 0 ? "#F44336" : "#000" }} />
                                    ):(
                                        <HorizontalRuleIcon sx={{ color: p.variableValueChange > 0 ? "#0AC665" : p.variableValueChange < 0 ? "#F44336" : "#000" }} />
                                    )}
                                    {Number.isInteger(p.variableValue) ? p.variableValue : p.variableValue.toFixed(2)}
                                </Grid>
                                <Grid className="variable-date">{p.variableDate}</Grid>
                                <Grid className="variable-last-value" sx={{
                                    color: p.variableValueChange > 0 ? "#0AC665" : p.variableValueChange < 0 ? "#F44336" : "#000"
                                }}>
                                    {p.variableLastValueDate && (
                                        <>
                                            {`(${p.variableLastValue})  ${p.variableValueChange.toFixed(2)}% (${p.variableLastValueDate})`}

                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>
            )}
            <Box className='chart-container'>
                {mergedActiveProfile?.config?.map((p: any, index: number) => {

                    let size: any = '45vw'
                    if (p?.size === 1) {
                        size = '90vw'
                    } else if (p?.size === 3) {
                        size = '30vw'
                    }

                    const config = { ...p }

                    return (
                        <ChartElement
                            key={index}
                            width={size}
                            config={config}
                            setShowChartInmodal={setShowChartInmodal}
                            fromModal={false}
                            filteredData={filteredData}
                            filters={filters}
                        />
                    )
                })}
                <div style={{ height: '50px', width: '100%' }} />
            </Box>
        </>
    )
}